import {
	findClosestElementByClass
} from "../helpers/dom/closest";
import {
	scrollToPosition
} from "../helpers/dom/scroll";
let clickToggleBox = [];
export const toggleBox = {
	element: null,
	options: {},
	toggle: function (options) {
		this.options = options;
		const elements = this.findElements(options.targetClassName);

		if (!elements.length) return;

		[].forEach.call(elements, (el) => {
			for (let i = 0; i < clickToggleBox.length; i++) {
				el.removeEventListener('click', clickToggleBox[i]);
			}
		});
		[].forEach.call(elements, (el, index) => {
			let that = this;
			el.addEventListener(
				'click', clickToggleBox[index] = function (e) {
					// console.log('click options', options, 'el', el);
					e.preventDefault();
					that.element = el;
					that.actionOnBox(el, options.parentClassName, options.contentClassName, options.state);
					that.changeTargetTextByDataset(el);
				}
			);
		});
	},
	findElements: function (className) {
		return document.querySelectorAll(`.${className}`);
	},
	changeTargetTextByDataset: function (element, ultimateState) {
		if (!element) return;
		const dataShow = element.dataset.show;
		const dataHide = element.dataset.hide;

		if (!dataShow || !dataHide) return;

		const txt = element.innerText.toUpperCase();

		//usunięte logi w konsoli po wysyłce formularza
		//console.log(txt, dataShow.toUpperCase(), (dataShow.toUpperCase() === txt), element);

		if (ultimateState === 'open') {
			element.classList.add('state-open');
			element.innerText = dataHide;
			element.setAttribute('aria-expanded', 'true');
			return;
		}
		if (txt.indexOf(dataShow.toUpperCase()) !== -1) {
			element.classList.add('state-open');
			element.innerText = dataHide;
			element.setAttribute('aria-expanded', 'true');
			// this.scrollToSubmitAction(element);
			return;
		}
		element.classList.remove('state-open');
		element.innerText = dataShow;
		element.setAttribute('aria-expanded', 'false');
	},
	actionOnBox: function (item, parentClass, contentClass, state) {
		const parent = findClosestElementByClass(item, parentClass);
		const contentBox = parent.querySelector(`.${contentClass}`);

		const displayState = getComputedStyle(contentBox).getPropertyValue('display');
		const action = this.setActionByState(state);
		action(contentBox, displayState === 'none' ? 'open' : 'close');
	},
	setActionByState: function (state) {
		if (!this[state]) {
			throw new Error('This method doesn\'t exist. Please select different method.');
		}
		return this[state];
	},
	showHide: function (box, noStyleState) {
		const $box = $(box);
		if (noStyleState === 'open') return $box.show();
		if (noStyleState === 'close') return $box.hide();
		if (!box.style.display || box.style.display === 'none') return $box.show();
		$box.hide();
	},
	scrollToSubmitAction: function (element) {
		// const parent = document.querySelector(`.${this.options.parentClassName}`);
		const parent = findClosestElementByClass(element, this.options.parentClassName);
		const submit = parent.querySelector('[data-submit]');

		// FIXME:
		// scrollToPosition(submit, 55, 1000); 
	}
};
